module.exports = __webpack_public_path__ + "static/img/bigdata11.84bdb5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigdata11.jpg
// module id = u1po
// module chunks = 0